module.exports = __webpack_public_path__ + "img/点击.9cb8bb0a.png";